var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"kiosk-configurations"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":[
      { title: this.$t('menu.leads'), disabled: true },
      { title: this.$t('menu.configurations'), disabled: true },
    ]}}),(_vm.hasReadLeadsEntitiesPermissions)?_c('KiosksTable',{attrs:{"collapsable":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }